import React from 'react'
import I18N from '@leverege/i18n'

import DemoScreenModel from './LiveLineStatusScreenModel'
import LiveLineStatusComponent from './LiveLineStatusComponent'

const id = 'tpi.dataViewers.LineLiveStatusDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'tpi.LineLiveStatusDataViewer',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'GroupDataViewer' },
  createSettings : ( props ) => {
    return DemoScreenModel.create()
  },
  render : ( props ) => {
    return React.createElement( LiveLineStatusComponent, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
